/** Whether Chart.js should render a legend for this chart configuration. */
export function resolveChartLegendDisplay({ chartType, builderChartType, showLegend, }) {
    const isPieType = chartType === 'pie';
    const isMultiSeriesLine = chartType === 'line' && (builderChartType === 'multiLine' || builderChartType === 'multivariate');
    if (isPieType || chartType === 'scatter') {
        return !!showLegend;
    }
    if (isMultiSeriesLine) {
        return true;
    }
    return undefined;
}
/** Shared Chart.js legend options for library preview and published reports. */
export function buildChartLegendOptions(params) {
    const isScatter = params.chartType === 'scatter';
    return {
        display: resolveChartLegendDisplay(params),
        position: 'right',
        align: 'start',
        labels: {
            usePointStyle: true,
            pointStyle: (isScatter ? 'circle' : 'rectRounded'),
            borderRadius: isScatter ? undefined : 8,
        },
    };
}
/**
 * Layout tokens for hand-built legends (e.g. funnel horizontal bar) so custom
 * markup stays on the same side and uses the same marker shapes as Chart.js.
 */
export const CHART_LEGEND_LAYOUT = {
    position: 'right',
    /** Wrapper for a vertical legend column placed to the right of the chart area. */
    containerClassName: 'flex flex-col gap-2 min-w-[200px]',
    itemClassName: 'flex items-center gap-3',
    markerClassName: {
        circle: 'size-4 shrink-0 rounded-full',
        rectRounded: 'size-4 shrink-0 rounded-lg',
    },
};
export function getChartLegendMarkerClassName(chartType) {
    return chartType === 'scatter'
        ? CHART_LEGEND_LAYOUT.markerClassName.circle
        : CHART_LEGEND_LAYOUT.markerClassName.rectRounded;
}
